import useGetAuthSessionQuery from '~/hooks/useGetAuthSessionQuery'
import { ECognitoGroups } from '~/models/auth'

export default function useIsAdmin() {
  const { data: authSession } = useGetAuthSessionQuery()
  const isAdmin = authSession?.groups.includes(ECognitoGroups.admin)

  return isAdmin
}
